/**
 * Mirror of `CSR_EXCLUDED_SMS_CHANNELS` in contactcenter-agent-inbox
 * (`frontend/packages/inbox-mfe/src/utils/excludedSmsChannels.ts`), which the
 * Texts rail passes as `excludeChannels`. The badge must exclude exactly the
 * same channels or it counts unreads the list hides (CCPE-2510). Keep the two
 * identical until the list is exported from
 * `@servicetitan/contactcenter-agent-inbox-mfe-loader` and imported here.
 */
export const CSR_EXCLUDED_SMS_CHANNELS: readonly string[] = [
  'Alert',
  'PoEmailAlert',
  'TaskManagement',
  'Spam',
  'ReviewEngine',
  'PhoneCapture',
  'SmsCampaignTest',
  'SecondChanceLeadsNotification',
  'InventoryReturnEmailAlert',
  'CustomerNotification',
  'PhoneConfirmation',
  'Technician',
];
